import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../../components/common/SectionHeading';

const Section = styled.section`
  margin-top: 4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const MainAward = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.5rem;
  padding: 2.5rem;
  box-shadow: ${({ theme }) => theme.shadows.lg};
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '🏆';
    position: absolute;
    top: 2rem;
    right: 2rem;
    font-size: 5rem;
    opacity: 0.15;
    z-index: 0;
  }
`;

const AwardInfo = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  z-index: 1;
`;

const AwardLine = styled.div`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  gap: 0.75rem;
  
  &:first-child {
    font-weight: 600;
    font-size: 1.25rem;
  }
`;

const AwardIcon = styled.span`
  font-size: 1.5rem;
  flex-shrink: 0;
`;

const AwardsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const AwardCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.25rem;
  padding: 1.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};
  transition: ${({ theme }) => theme.transitions.default};
  display: flex;
  align-items: flex-start;
  gap: 1rem;

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }
`;

const CardIcon = styled.div`
  font-size: 2rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 0.75rem;
`;

const AwardText = styled.div`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.6;
  flex: 1;
`;

const StorySection = () => (
  <Section id="story">
    <MainAward>
      <SectionHeading
        eyebrow="수상 내역"
        title="제3회 초중고 문화경진대회"
        description=""
      />
      <AwardInfo>
        <AwardLine>
          <AwardIcon>👤</AwardIcon>
          중등부 송동해
        </AwardLine>
        <AwardLine>
          <AwardIcon>🥇</AwardIcon>
          포스터부문 1위
        </AwardLine>
        <AwardLine>
          <AwardIcon>🏅</AwardIcon>
          식품의약품안전처장상 수상
        </AwardLine>
      </AwardInfo>
    </MainAward>
    <AwardsGrid>
      <AwardCard>
        <CardIcon>🎬</CardIcon>
        <AwardText>숏폼부문 전컴회장상<br />중등부 김나림</AwardText>
      </AwardCard>
      <AwardCard>
        <CardIcon>🎨</CardIcon>
        <AwardText>포스터부문 전컴회장상<br />초등부 김강유</AwardText>
      </AwardCard>
      <AwardCard>
        <CardIcon>🎨</CardIcon>
        <AwardText>포스터부문 전컴회장상<br />초등부 윤건</AwardText>
      </AwardCard>
    </AwardsGrid>
  </Section>
);

export default StorySection;


